import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["trend", "department"];

  connect() {
    this.renderTrendPlaceholder();
    this.renderDepartmentPlaceholder();
  }

  renderTrendPlaceholder() {
    if (!this.hasTrendTarget) return;

    if (!this.trendTarget.querySelector("canvas")) {
      const placeholder = document.createElement("div");
      placeholder.className = "text-sm text-gray-400";
      placeholder.textContent = this.t('js.rh.teacher_attendances.entrypoints.dashboard.placeholders.chart_pending');
      this.trendTarget.appendChild(placeholder);
    }
  }

  renderDepartmentPlaceholder() {
    if (!this.hasDepartmentTarget) return;

    if (!this.departmentTarget.querySelector("canvas")) {
      const placeholder = document.createElement("div");
      placeholder.className = "text-sm text-gray-400";
      placeholder.textContent = this.t('js.rh.teacher_attendances.entrypoints.dashboard.placeholders.chart_pending');
      this.departmentTarget.appendChild(placeholder);
    }
  }

  t(key, options = {}) {
    if (typeof window !== "undefined" && typeof window.t === "function") {
      return window.t(key, options);
    }
    return key;
  }
}
